import {combineReducers} from 'redux';
import {appsByCategory} from './apps-by-category';
import {categories} from './categories';
import {apps} from './apps';
import {collection} from './collection';
import {search} from './search';
import {reviews} from './reviews';
import {appsByType} from './apps-by-type';
import {mode} from './mode';
import {popup} from './popup';

export default combineReducers({
  appsByCategory,
  appsByType,
  categories,
  apps,
  collection,
  search,
  reviews,
  mode,
  popup
});



// WEBPACK FOOTER //
// ./reducers/index.js